export enum StatusModuloStudente {
  aperto = 'APERTO',
  consegnato = 'CONSEGNATO',
  studente = 'STUDENTE',
  docente = 'DOCENTE',
}
